<template>
  <div>
    <div>
      <!-- <div id="FuncInfo"></div> -->
      <First v-if="showData"></First>

      <div class="foot-btn">
        <div class="num-box fl" @click="Already">
          <div class="num-select">
            <img class="num-icon" src="@/assets/infoPublic/images/like@2x.png" />
            <span class="num-like">已选择</span>
          </div>
          <span class="num-text"><span>{{selectCard}}/{{this.treeListGroup.num}}</span>个</span>
        </div>
        <van-button round type="info" class="num-sure fr" @click.native="Submission">确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import First from './First'
  export default {
    name: "SelectClassCard",
    components:{
      'First':First
    },
    data() {
      return {
        type: 0,
        filesUrls: [],
        imgFile: {},
        treeListGroup: {
          ClassTerminalGroupID: -1,
          ClassTerminalGroupName: "全部分组",
          TreminalS: [],
          children: [],
          isCheck: false,
          num: 0
        },
        search: '',
        contList: [],
        parentList:[],

        selectCard: 0,
        idList: [],

        // 编辑反绑定
        noticeData: '',

        classTerminal: [],
        checkedArr: [],
        IDs: 0,
        isEdit: false,

        //
        showData: false,
        videoFileSize: ''
      };
    },
    computed: {
    },
    mounted () {
      this.filesUrls = this.$store.state.infoPublic.PicfilesUrls;
      this.videoFileSize = this.$store.state.infoPublic.fileSize;
      // 类型
      this.type = this.$store.state.infoPublic.typePic;

      // 返回已选班牌
      this.classTerminal = this.$store.state.infoPublic.classTerminal;
      console.log(this.classTerminal)
      console.log(this.classTerminal.length)
      this.selectCard = this.classTerminal.length;
      // this.checkedArr = this.classTerminal

      if (this.classTerminal.length > 0) {
        this.noticeData = this.$store.state.infoPublic.PublishTaskInfo;
      } else {
        this.noticeData = this.$store.state.infoPublic.noticeData;
      }
      

    },
    created () {
      this.GetTreminalTree();

    },
    methods: {
      // 获取班牌
      async GetTreminalTree () {
        this.xy.loading();
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/ClassTerminalGroup/GetTreminalTree`);
        this.xy.unloading();
        if (res.success) {
          if (res.data.length > 0) {
            this.treeListGroup.children = res.data;
            this.treeList = this.treeListGroup.children;
            this.$store.state.infoPublic.treeListGroup = this.treeList
            console.log(this.treeList)
            if(this.treeList.length>0) {
              this.showData = true
            }else{
              this.showData = false
            }
            // this.loadList();
          } else {
            this.xy.msgError("暂无班牌");
          }
        }else{
          // this.$toast.fail(res.msg);
          this.xy.msgError(res.msg);
        }
        this.treeList = this.treeListGroup.children;
        this.loadList();
      },

      // 计算班牌总数量 循环到每一个班牌
      loadList(){
        if (this.treeList.length > 0) {
          // 一级组
          for (var i = 0; i < this.treeList.length; i++) {
            this.$set(this.treeList[i], 'isCheck', false);
            this.$set(this.treeList[i], 'num', 0);
            //一级班牌
            if (this.treeList[i].TreminalS.length > 0) {
              for (var y = 0; y < this.treeList[i].TreminalS.length; y++) {
                this.$set(this.treeList[i].TreminalS[y], 'isCheck', false);
              }
              this.treeList[i].num += this.treeList[i].TreminalS.length;
            }
            // 二级组
            if (this.treeList[i].children.length > 0) {
              for (var x = 0; x < this.treeList[i].children.length; x++) {
                this.$set(this.treeList[i].children[x], 'isCheck', false);
                this.$set(this.treeList[i].children[x], 'num', 0);

                // 二级班牌
                if (this.treeList[i].children[x].TreminalS.length > 0) {
                  for (var n = 0; n < this.treeList[i].children[x].TreminalS.length; n++) {
                    this.$set(this.treeList[i].children[x].TreminalS[n], 'isCheck', false);
                  }
                  this.treeList[i].num += this.treeList[i].children[x].TreminalS.length;
                  this.treeList[i].children[x].num += this.treeList[i].children[x].TreminalS.length;
                }
                // 三级组
                if (this.treeList[i].children[x].children.length > 0) {
                  for (var a = 0; a < this.treeList[i].children[x].children.length; a++) {
                    this.$set(this.treeList[i].children[x].children[a], 'isCheck', false);
                    this.$set(this.treeList[i].children[x].children[a], 'num', 0);

                    // 三级班牌
                    if (this.treeList[i].children[x].children[a].TreminalS.length > 0) {
                      for (var q = 0; q < this.treeList[i].children[x].children[a].TreminalS.length; q++) {
                        this.$set(this.treeList[i].children[x].children[a].TreminalS[q], 'isCheck', false);
                      }
                      this.treeList[i].num += this.treeList[i].children[x].children[a].TreminalS.length;
                      this.treeList[i].children[x].num += this.treeList[i].children[x].children[a].TreminalS.length;
                      this.treeList[i].children[x].children[a].num += this.treeList[i].children[x].children[a].TreminalS.length;
                    }
                    // 四级组
                    if (this.treeList[i].children[x].children[a].children.length > 0) {
                      for (var c = 0; c < this.treeList[i].children[x].children[a].children.length; c++) {
                        this.$set(this.treeList[i].children[x].children[a].children[c], 'isCheck', false);
                        this.$set(this.treeList[i].children[x].children[a].children[c], 'num', 0);

                        // 四级班牌
                        if (this.treeList[i].children[x].children[a].children[c].TreminalS.length > 0) {
                          for (var h = 0; h < this.treeList[i].children[x].children[a].children[c].TreminalS.length; h++) {
                            this.$set(this.treeList[i].children[x].children[a].children[c].TreminalS[h], 'isCheck', false);
                          }
                          this.treeList[i].num += this.treeList[i].children[x].children[a].children[c].TreminalS.length;
                          this.treeList[i].children[x].num += this.treeList[i].children[x].children[a].children[c].TreminalS.length;
                          this.treeList[i].children[x].children[a].num += this.treeList[i].children[x].children[a].children[c].TreminalS.length;
                          this.treeList[i].children[x].children[a].children[c].num += this.treeList[i].children[x].children[a].children[c].TreminalS.length;
                        }
                      }
                    }
                  }
                }
              }
            }
            // 总数
            this.treeListGroup.num += this.treeList[i].num;
          }
        } else {
          // 暂无组
        }

        // 反选
        if (this.classTerminal.length > 0) {
          this.classTerminalSelect(this.treeListGroup);
          this.classTerminalNum();
        }
        this.loadPage();
        console.log(this.treeListGroup);
      },

      // 反选
      classTerminalSelect (val) {
        if (val.TreminalS.length > 0) {
          for (var i = 0; i < this.classTerminal.length; i++) {
            for (var c = 0; c < val.TreminalS.length; c++) {
              if (this.classTerminal[i].ClassTerminalId === val.TreminalS[c].ClassTerminalId) {
                val.TreminalS[c].isCheck = true;
              }
            }
          }
        }
        if (val.children.length > 0) {
          for (var j = 0; j < val.children.length; j++) {
            this.classTerminalSelect(val.children[j])
          }
        }
      },


      // 反选人数
      classTerminalNum () {
        var Num = [];
        for (var i = 0; i < this.classTerminal.length; i++) {
          Num.push(this.classTerminal[i].ClassTerminalId)
        }
        // console.log(Num)
        this.checkedFunc(Num)
      },
      
      // 选中
      checkedFunc (id) {
        // classTerminal
        this.selectCard = 0;
        if (typeof id === "number") {
          // 数组与id去重
          for (let i = 0; i < this.checkedArr.length; i++) {
            if (this.checkedArr[i] === id) {
              this.checkedArr.splice(i, 1)
            }
          }
          this.checkedArr.push(id)
        } else {
          // 两数组去重
          var arr = this.checkedArr.concat();
          for (let i = 0; i < id.length; i++) {
            if(id[i] !== undefined){
                 arr.indexOf(id[i]) === -1 ? arr.push(id[i]) : 0;
            }
          }
          this.checkedArr = arr
        }
        this.selectCard = this.checkedArr.length;
        // 已选中的班牌id
      },

      // 加载组件
      loadPage(){
        this.$store.commit('infoPublic/settreeListGroup', this.treeListGroup);
        this.$store.commit('infoPublic/setnoticeData', this.noticeData);
        this.$store.commit('infoPublic/settypePic', this.type);
        this.$store.commit('infoPublic/setcontList', this.contList);
      },

      // 选中组下所有id班牌
      numList (json) {
        if (json.hasOwnProperty('num')) {
          // 点击的组
          if (json.TreminalS.length > 0) {
            for (var i = 0; i < json.TreminalS.length; i++) {
              // 判断值不为 undefined
              if (json.TreminalS[i].ClassTerminalId !== undefined) {
                if (this.type === 11) {
                  if (json.TreminalS[i].ScreenMode === this.noticeData.ScreenMode) {
                    this.contList.push(json.TreminalS[i].ClassTerminalId)
                  }
                } else {
                  this.contList.push(json.TreminalS[i].ClassTerminalId)
                }
              }else{
                console.log(json.TreminalS[i]['ClassTerminalId'])
              }
            }
          }
          console.log(this.contList)
          if (json.children.length > 0) {
            for (var j = 0; j < json.children.length; j++) {
              this.numList(json.children[j]);
            }
          } else {
            return;
          }
        } else {
          console.log("我没有")
          // 点击的班牌
          // 判断值不为 undefined
          if (json.ClassTerminalId !== undefined) {
            this.contList.push(json.ClassTerminalId)
          }
        }
        console.log(this.contList,"????添加过的")
      },

      // 控制 isCheck 显示隐藏
      alreadyElement (val) {
        if (val.isCheck) {
          if (val.hasOwnProperty('num')) {
            if (val.TreminalS.length > 0) {
              for (var i = 0; i < val.TreminalS.length; i++) {
                // val.TreminalS[i].isCheck = true;
                if (this.type === 11) {
                  if (val.TreminalS[i].ScreenMode === this.noticeData.ScreenMode) {
                    val.TreminalS[i].isCheck = true;
                  } else {
                    val.TreminalS[i].isCheck = false;
                  }
                } else {
                  val.TreminalS[i].isCheck = true;
                }
              }
            }
            if (val.children.length > 0) {
              for (var j = 0; j < val.children.length; j++) {
                val.children[j].isCheck = true;
                this.alreadyElement(val.children[j]);
              }
            }
          } else {
            val.isCheck = true;
          }
        } else {
          if (val.hasOwnProperty('num')) {
            if (val.TreminalS.length > 0) {
              for (let i = 0; i < val.TreminalS.length; i++) {
                // val.TreminalS[i].isCheck = false;
                if (this.type === 11) {
                  if (val.TreminalS[i].ScreenMode === this.noticeData.ScreenMode) {
                    val.TreminalS[i].isCheck = false;
                  }
                } else {
                  val.TreminalS[i].isCheck = false;
                }
              }
            }
            if (val.children.length > 0) {
              for (let j = 0; j < val.children.length; j++) {
                val.children[j].isCheck = false;
                this.alreadyElement(val.children[j]);
              }
            }
          } else {
            val.isCheck = false;
          }
        }
      },

      // 控制父级 isCheck 显示隐藏
      alreadyParent (val) {
        this.parentList = [];
        this.selectParent(val);
        for (var i = 0; i < this.parentList.length; i++) {
          if (!this.parentList[i].isCheck) {
            val.isCheck = false;
            break ;
          } else {
            val.isCheck = true;
          }
        }
      },
      selectParent (val) {
        if (val.TreminalS.length > 0) {
          for (var i = 0; i < val.TreminalS.length; i++) {
            this.parentList.push(val.TreminalS[i])
          }
        }
        if (val.children.length > 0) {
          for (var j = 0; j < val.children.length; j++) {
            this.selectParent(val.children[j]);
          }
        }
      },

      // // 删除
      removeElement (id) {
        if (typeof id === "number") {
          this.checkedArr.splice( this.checkedArr.indexOf(id), 1);
        } else {
          id.forEach(idItem=> {
            this.checkedArr.splice( this.checkedArr.indexOf(idItem), 1);
          })
        }
        this.selectCard =  this.checkedArr.length;
        // 已选中的班牌id
        console.log( this.checkedArr)
      },

      // 获取搜索
      async GetPage () {
        this.xy.loading();
        var obj = {
          PageIndex: 1,
          PageSize: 6,
          SearchText: this.search,
          ClassTerminalGroupID: 0,
          SchoolDistrictID: 0,
          BuildingID: 0,
        }
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/ClassTerminal/GetPage`,obj);
        this.xy.unloading();
        if (res.success) {
          if (res.data.data.length > 0) {
            this.treeListGroup.TreminalS = res.data.data;
          } else {
            // 暂无班牌
          }
        }else{
          this.$toast.fail('获取班牌列表失败');
        }
      },

      //搜索
      submitHandler () {
        this.GetPage();
      },
      //搜索--取消
      HandlerCancel () {
        this.search = "";
        this.GetPage();
      },

      // 已选择
      Already () {
        // 跳转页面
        console.log(this.checkedArr)
        if (this.checkedArr.length > 0) {
          this.$store.commit('infoPublic/settypePic', this.type);
          this.$store.commit('infoPublic/setPicfilesUrls', this.filesUrls);
          this.$store.commit('infoPublic/setclassTerminal', this.classTerminal);
          this.$store.commit('infoPublic/settreeListGroup', this.treeListGroup);
          this.$store.commit('infoPublic/setnoticeData', this.noticeData);
          this.$store.commit('infoPublic/setcheckedArr', this.checkedArr);
          this.$router.push('/home/Already');
        } else {
          this.xy.msgError("请选择班牌!");
        }
      },

      // 取js随机数
      randomn (n) {
        if (n > 21) return null
        var re = new RegExp("(\\d{" + n + "})(\\.|$)")
        var num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(re)[1]
        this.taskName = num;
      },

      // 确定
      async Submission () {
        // this.xy.loading();
        this.randomn(6);
        if (this.type !== 7 && this.type !== 8 && this.type !== 11 ) {
          if ( this.filesUrls === undefined) {
            this.isEdit = true;
          } else {
            //我们可以预先定义一个FormData对象
            var formData = {};
            formData.Data = this.$store.state.infoPublic.picArr
            formData.BussinessStr = ''

            this.formData = formData;
          }
        }
        if ( this.checkedArr.length > 0) {
          // 班牌ID []
          this.idList =  this.checkedArr;

          if (this.type === 9) {
            // 发布图片
            // Resource/CreatePhotoMobile
            if ( this.isEdit) {
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/EditPublicTask`,{
                PublishTaskID:  this.noticeData.PublishTaskID,
                PublishTaskName:  this.noticeData.PublishTaskName,
                PublishTaskType:  this.type,//资源类型9
                ClassTerminalID:  this.idList,//班牌ID
              });
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('发布到班牌成功');
              }else{
                this.$toast.fail(res.msg);
              }
            } else {
              this.xy.loading();
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/Resource/CreatePhotoMobile`,  this.formData);
              this.xy.unloading();
              let _res = res;
              if (res.success) {
                let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/CreatePublicTask`,{
                  PublishTaskName: "手机端发布图片" +  this.taskName,
                  PublishTaskType:  this.type,//资源类型8
                  ClassTerminalID:  this.idList,//班牌ID
                  ResourceID: _res.data.result//资源ID
                });
                if(res.success){
                  // 跳转到成功页面
                  this.$router.push('/home/OperationSuccessful');
                  this.$toast.fail('发布到班牌成功');
                }else{
                  this.$toast.fail(res.msg);
                }
              }else{
                this.$toast.fail(res.msg);
              }
            }
          } else if (this.type === 8) {
            // 发布视频
            // Resource/UploadVideoMobile
            if ( this.isEdit) {
              this.xy.loading();
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/EditPublicTask`,{
                PublishTaskID:  this.noticeData.PublishTaskID,
                PublishTaskName:  this.noticeData.PublishTaskName,
                PublishTaskType:  this.type,//资源类型9
                ClassTerminalID:  this.idList,//班牌ID
              });
              this.xy.unloading();
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('发布到班牌成功');
              }else{
                this.$toast.fail(res.msg);
              }
            } else {
                let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/Resource/UploadVideoMobile`, {
                  fileName: String(this.filesUrls),
                  fileSize:this.videoFileSize
                });
                this.xy.unloading();
                if (res.success) {
                  let re = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/CreatePublicTask`,{
                    PublishTaskName: "手机端发布视频" +  this.taskName,
                    PublishTaskType:  this.type,//资源类型8
                    ClassTerminalID:  this.idList,//班牌ID
                    ResourceID: [res.data]//资源ID
                  });
                  if (re.success) {
                    // 跳转到成功页面
                    this.$router.push('/home/OperationSuccessful');
                    this.$toast.fail('发布到班牌成功');
                  }else{
                    this.$toast.fail(re.msg);
                  }
                }else{
                  this.$toast.fail(res.msg);
                }

            }
          } else if (this.type === 7) {
            // 发布通知
            if (this.classTerminal.length > 0) {
              // 编辑
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/EditPublicTask`,{
                PublishTaskName:  this.noticeData.PublishTaskName,
                PublishTaskID:  this.noticeData.PublishTaskID,
                ClassTerminalID:  this.idList
              });
              this.xy.unloading();
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('编辑到班牌成功');
              }else{
                this.xy.unloading();
                this.$toast.fail(res.msg);
              }
            } else {
              // 新建
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/Resource/CreateInformMobile`,{
                InformTypeID:  this.noticeData.InformTypeID,
                InformName:  this.noticeData.InformName,
                InformColorID:  this.noticeData.InformColorID,
                InformContent:  this.noticeData.InformContent,
                StartDate:  this.noticeData.StartDate,
                EndDate:  this.noticeData.EndDate,
                ClassTerminalID:  this.idList
              });
              this.xy.unloading();
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('发布到班牌成功');
              }else{
                this.xy.unloading();
                this.$toast.fail(res.msg);
              }
            }
          } else if (this.type === 10) {
            // 新闻
            if ( this.isEdit) {
              this.xy.loading();
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/EditPublicTask`,{
                PublishTaskID:  this.noticeData.PublishTaskID,
                PublishTaskName:  this.noticeData.PublishTaskName,
                PublishTaskType:  this.type,//资源类型9
                ClassTerminalID:  this.idList,//班牌ID
              });
              this.xy.unloading();
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('发布到班牌成功');
              }else{
                this.$toast.fail(res.msg);
              }
            }

          } else if (this.type === 29) {
            // 欢迎
            if ( this.isEdit) {
              this.xy.loading();
              let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/PublicTask/EditPublicTask`,{
                PublishTaskID:  this.noticeData.PublishTaskID,
                PublishTaskName:  this.noticeData.PublishTaskName,
                PublishTaskType:  this.type,//资源类型9
                ClassTerminalID:  this.idList,//班牌ID
              });
              this.xy.unloading();
              if (res.success) {
                // 跳转到成功页面
                this.$router.push('/home/OperationSuccessful');
                this.$toast.fail('发布到班牌成功');
              }else{
                this.$toast.fail(res.msg);
              }
            }
          }
        } else {
          this.xy.unloading();
          this.$toast.fail('请选择所要发布的班牌');
        }
      },

    }
  };
</script>
<style lang="less" scoped>
  .foot-btn {
    height: 100px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
  }
  .foot-btn > .num-box {
    width: 230px;
    height:90px;
    background: #f2f2f2;
    border-radius: 0 45px 45px 0;
    margin-top:6px;
  }

  .foot-btn > .num-box > .num-select {
    display: block;
    margin-left: 48px;
    margin-top: 20px;
  }
  .foot-btn > .num-box > .num-select > .num-icon {
    display:inline-block;
    width:36px;

  }
  // .foot-btn > .num-box > .num-select > .num-like {
  // }

  .foot-btn > .num-box > .num-text {
    display: block;
    margin-left: 48px;
    color: #040404;
    font-size: 28px;
  }
  .foot-btn > .num-box > .num-text > span {
    color: #040404;
    font-size: 20px;
  }
  .foot-btn > .num-sure {
    width: 220px;
    height: 74px;
    font-size: 32px;
    margin-top: 18px;
    margin-right: 32px;
  }

  /* 选择班牌第一级 */
  .first {
    margin-bottom: 100px;
  }
  .nav-top {
    background: #fff;
    height: 80px;
    padding: 0 2%;
    line-height: 80px;
    overflow:hidden;
  }
  .nav-top > .nav-list {
    white-space: nowrap;
    width: 80%;
    overflow: auto;
  }
  .nav-top > .nav-list > div {
    font-size: 28px;
    display:inline-block;
    margin:0 10px;
  }
  .nav-top > .all {
    margin-top: 10px;
  }
  .nav-active {
    color: #4196FF;
  }
  // .check-group-list-box {
  // }
  .check-group-list-box > .check-group-list {
    background: #fff;
    margin-bottom:100px;
  }
  .check-group-list-box > .check-group-list > .check-group-list-div {
    white-space: nowrap;
  }
  .check-group-list-row {
    display: inline-block;
    height: 100px;
    line-height: 100px;
    border-top: 1px solid #f2f2f2;
    padding: 0;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor:pointer;
  }
  // .check-group-list-row > .check-group-list-check {
  // }
  .check-group-list-row > .check-group-list-check > i {
    font-size: 40px;
    color: #4196FF;
    display: inline-block;
    vertical-align: middle;
    margin: 30px 20px 30px 30px;
  }

  .check-group-list-row-dis {
    display: inline-block;
    height: 100px;
    line-height: 100px;
    border-top: 2px solid #f2f2f2;
    padding: 0;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  // .check-group-list-row-dis > .check-group-list-check {
  // }

  .check-group-list-row-dis > .check-group-list-check > i {
    font-size: 40px;
    color: #cacaca;
    display: inline-block;
    vertical-align: middle;
    margin: 30px 20px 30px 30px;
  }

  .check-group-list-row-dis > .check-group-list-name {
    color: #999;
  }

  .check-ban-icon {
    width:38px;
  }

  // .check-group-list-name {
  // }
  .check-group-list-icon {
    width: 20%;
    height: 100px;
    font-size: 48px;
    color: #999;
    line-height: 100px;
    text-align: center;
    display: inline-block;
    cursor:pointer;
  }


  /* 已选班牌 */
  .already-box {
    background:#fff;
  }
  .already-box > .already-list {
    height: 100px;
    line-height: 100px;
    border-top: 1px solid #f2f2f2;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    padding: 0 0 0 30px;
  }

  .already-box > .already-list > .already-row {
    display: inline-block;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .already-box > .already-list > .already-del {
    display: inline-block;
    width: 18%;
    vertical-align: middle;
    text-align: center;
    color: #F85F30;
  }
</style>
